// src/api/queueApi.js
const API_BASE = process.env.REACT_APP_API_BASE || "https://us-central1-achados-67630.cloudfunctions.net/api";

async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    throw new Error(`Resposta inválida do servidor: ${text?.slice(0, 120)}`);
  }
}

export async function fetchQueue(day) {
  const res = await fetch(`${API_BASE}/queue?day=${encodeURIComponent(day)}`);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Falha ao buscar fila");
  }
  return parseJson(res); // { items: [...] }
}

export async function createQueueItem(payload) {
  const res = await fetch(`${API_BASE}/queue`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Falha ao criar item");
  }
  return parseJson(res); // { item: ... }
}

// ✅ agora envia positions também
export async function reorderQueue(day, orderedIds, positions) {
  const res = await fetch(`${API_BASE}/queue/reorder`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ day, orderedIds, positions }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Falha ao reordenar fila");
  }
  return parseJson(res); // { items: [...] }
}

export async function updateQueueItem(id, payload) {
  const res = await fetch(`${API_BASE}/queue/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Falha ao atualizar item");
  }
  return parseJson(res);
}

export async function deleteQueueItem(id) {
  const res = await fetch(`${API_BASE}/queue/${id}`, { method: "DELETE" });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Falha ao deletar item");
  }
  return parseJson(res);
}
